/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { ILdsCountryMessageViewProps } from './lds-country-message';
// @ts-ignore
// import Modal from '../../../eden/eden-content-modal';
import { Info, Modal } from '@churchofjesuschrist/eden-alert';
//@ts-ignore
import { Primary } from '@churchofjesuschrist/eden-buttons';
import CountryNotice from '../../helpers/utilities/country-notice';
import { getCountryLanguageAsync } from '../../actions/DataActionExtension.g';
import { format } from '@msdyn365-commerce-modules/utilities';

const CountryMessage: React.FC<ILdsCountryMessageViewProps> = props => {
    const [visible, setVisible] = React.useState(false);
    const [countries, setCountries] = React.useState<any>();
    const [shouldShowLocalCurrency, setShouldShowLocalCurrency] = React.useState<any>(false);
    const messageLanguage = props.context.request.locale === 'es' ? 'es' : 'en-us';

    let popUpMessage: any = [];
    //@ts-ignore
    if (props.data.cart && props.data.cart.result && props.data.cart.result.cart) {
        //@ts-ignore
        const userCountry = props.data.cart.result.cart.ExtensionProperties?.find((x: any) => x.Key === 'Country')?.Value.StringValue;
        popUpMessage = CountryNotice.filter(notice => {
            return (
                //@ts-ignore
                notice.countryRegionId === userCountry && notice.lang === messageLanguage
            );
        });
    }
    const getCountry = async () => {
        const ctx = { callerContext: props.context.actionContext };
        const countries = await getCountryLanguageAsync(ctx, props.context.actionContext.requestContext.channel!.RecordId, 'en-us').catch(
            (err: any) => {
                console.log(err);
            }
        );
        setCountries(countries);
        return countries;
    };
    React.useEffect(() => {
        setVisible(true);
        void getCountry();
    }, []);
    let currentCountry: any;
    if (
        props &&
        props.data &&
        //@ts-ignore
        props.data.cart &&
        //@ts-ignore
        props.data.cart.result &&
        //@ts-ignore
        props.data.cart.result.cart &&
        //@ts-ignore
        props.data.cart.result.cart.ExtensionProperties
    ) {
        //@ts-ignore
        currentCountry = props.data.cart.result.cart
            ? //@ts-ignore
              props.data.cart.result.cart.ExtensionProperties?.find((x: any) => x.Key === 'Country')?.Value.StringValue
            : '';
    }
    let countryData: any;
    if (countries && countries.length > 1) {
        countryData = countries.filter((country: any) => {
            return country.countryRegionId === currentCountry;
        });
    }
    // let shouldShowLocalCurrency;
    React.useEffect(() => {
        if (countryData && countryData[0] && shouldShowLocalCurrency !== true) {
            // shouldShowLocalCurrency =
            //@ts-ignore
            countryData[0].ExtensionProperties[7].Value?.StringValue === countryData[0].ExtensionProperties[8].Value?.StringValue
                ? null
                : setShouldShowLocalCurrency(true);
        }
    }, [countries]);

    return (
        <div className='row'>
            {/* {visible && popUpMessage.length > 0 ? (
                //@ts-ignore
                <PopUp
                    message={popUpMessage}
                    resources={props.resources}
                    shouldShowLocalCurrency={shouldShowLocalCurrency}
                    config={props.config}
                />
            ) : null} */}
            {visible && props.config.popUpMessage ? (
                //@ts-ignore
                <PopUp message={props.config.popUpMessage} resources={props.resources} shouldShowLocalCurrency={shouldShowLocalCurrency} />
            ) : null}
            {visible && shouldShowLocalCurrency && popUpMessage.length === 0 && (
                // @ts-ignore
                <CurrencyPopUp resources={props.resources} context={props.context} />
            )}
        </div>
    );
};

export default CountryMessage;

export const PopUp: React.FC<any> = ({ message, resources, shouldShowLocalCurrency }) => {
    const [isOpen, setIsOpen] = React.useState(true);

    const countryMessage = sessionStorage.getItem('isCountryMessageOpen');
    const closePopUp = () => {
        if (!countryMessage) {
            sessionStorage.setItem('isCountryMessageOpen', 'false');
        }

        setIsOpen(false);
    };
    return (
        <Modal open={countryMessage === 'false' ? false : isOpen}>
            <Info>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <h3 style={{ paddingTop: '3px' }}>{resources.currencyHeader}</h3>
                    <div
                        style={{ marginTop: '-8px', fontSize: '16px' }}
                        dangerouslySetInnerHTML={{ __html: message[0].value ? message[0].value : message }}
                    />
                    <div>
                        <div style={{ display: 'flex', justifyContent: 'space-around', marginTop: '40px' }}>
                            <Primary onClick={() => closePopUp()} style={{ width: '100%' }}>
                                {resources.closeNotificationLabel}
                            </Primary>
                        </div>
                    </div>
                </div>
            </Info>
        </Modal>
    );
};

export const CurrencyPopUp: React.FC<any> = ({ resources, context }) => {
    const [isOpen, setIsOpen] = React.useState(true);

    const currencyMessage = sessionStorage.getItem('isCurrencyOpen');
    const closePopUp = () => {
        if (!currencyMessage) {
            sessionStorage.setItem('isCurrencyOpen', 'false');
        }
        setIsOpen(false);
    };

    return (
        <Modal open={currencyMessage === 'false' ? false : isOpen}>
            <Info>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <h3 style={{ paddingTop: '3px' }}>{resources.currencyHeader}</h3>
                    <span style={{ marginTop: '10px', fontSize: '16px' }}>
                        {format(resources.currencyFeeMessage, context.cultureFormatter.currencyCode)}
                    </span>
                    <div>
                        <div style={{ display: 'flex', justifyContent: 'space-around', marginTop: '40px' }}>
                            <Primary onClick={() => closePopUp()} style={{ width: '100%' }}>
                                {resources.closeNotificationLabel}
                            </Primary>
                        </div>
                    </div>
                </div>
            </Info>
        </Modal>
    );
};
